export default __webpack_public_path__ + "static/media/WINE7.48433e08.jpg";